import { QueryClient } from '@tanstack/react-query';

// Single app-wide React Query client. Exported as a module singleton so non-React
// callers (e.g. the MobX TreadAgentStore, which invalidates conversation queries when a
// streamed turn completes) can reach the same cache that QueryClientProvider serves.
export const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});
